<Input
  id={{this.field.id}}
  step="0.01"
  @type="number"
  @value={{this.field.value}}
  tabindex={{this.field.tabindex}}
  class={{this.fieldClass}}
/>